
import WhatsAppSettingsCard from '@/components/whatsapp/WhatsAppSettingsCard.vue';
import { ProjectViewMixin } from '@/mixins/ProjectViewMixin';
import { Bot, WhatsAppPlatformData, SupportedPlatform } from 'ignite360-core';
import _merge from 'lodash.merge';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'project-platform-whatsapp',
  components: {
    'whatsapp-settings-card': WhatsAppSettingsCard,
  },
})
export default class ProjectPlatformWhatsApp extends mixins(ProjectViewMixin) {
  onConnect(data: Partial<WhatsAppPlatformData>) {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.WhatsApp]: data,
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }

  onDisconnect() {
    const newBot: Bot = _merge({}, this.bot, {
      platformData: {
        [SupportedPlatform.WhatsApp]: {
          pageId: '',
          pageName: '',
          pageAccessToken: '',
          businessAccountId: '',
        },
      },
    });
    this.$store.commit('bots/updateBot', newBot);
  }
}
